export const FETCH_PARAMETERS = 'FETCH_PARAMETERS'
export const SET_PARAMETERS = 'SET_PARAMETERS'
